<div class="game__countdown">
  <h3>{{ formattedTime() }}</h3>
</div>

